import { DataBean } from "../../DataBean";


export class RiskFactoryType extends DataBean {


    public async getRiskFactoryTypeCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getRiskFactoryTypeCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}